export default {
  // layout
  LAYOUT: {
    header: {
    },
    footer: {
    },
    uploading: {
    },
    dialog: {
      toast: {
      }
    }
  },
  // page
  PAGE: {
  },
  // component
  COMPONENT: {
  },
  // common
  COMMON: {
    button: {
    },
    toast: {
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/en/lang.js